import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'
import { serializeFiltro, serializePaginate } from '@/services/serialize'

export async function list (filtros, all = false) {
  return httpAuth.get(`/admin/usuarios?${serialize({ ...filtros, all })}`, { tela: 'controledeacesso_usuario' })
}

export async function listarComFiltros (filtros, all = false) {
  return httpAuth.get(`/admin/usuarios-filtro?${serializeFiltro('filtroComposto', filtros)}&${serializePaginate(all)}`)
}

export async function get (id) {
  return httpAuth.get(`/admin/usuarios/${id}`, { tela: 'controledeacesso_usuario' })
}

export async function uploadAvatar (file, usuarioId) {
  await httpAuth.post(`/admin/uploadavatar/${usuarioId}`, file)
}

export async function add (dados) {
  return httpAuth.post('/admin/usuarios', dados, { funcionalidade: 'controledeacesso_usuario_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/admin/usuarios/${id}`, dados, { funcionalidade: 'controledeacesso_usuario_editar' })
}

export async function editar (id, dados) {
  return httpAuth.put(`/admin/usuarios/${id}`, dados)
}

export async function del (id) {
  return httpAuth.delete(`/admin/usuarios/${id}`, { funcionalidade: 'controledeacesso_usuario_excluir' })
}
